import { render } from "./forgot.vue?vue&type=template&id=7707993f&scoped=true"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"

import "./forgot.vue?vue&type=style&index=0&id=7707993f&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7707993f"]])

export default __exports__